module.exports = __webpack_public_path__ + "img/cutlery.814ad672.svg";